import React from 'react';
import { useHistory } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Well, FormHeading, Form } from '../../../form';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import ErrorList from '../../../errorList';
import SettingsForm from '../form';
import {DangerZone} from '../form';
import schema from '../form/schema';
import updateSettings from './updateSettings';
import { useDataFetcher } from '../../../hooks';

export const EditSettingsPage: React.FC = () => {
  const history = useHistory();

  const { busy, errors, data: theme } = useDataFetcher('api/settings');

  return (
    <Container fluid>
      <Well>
        <FormHeading title="Settings" subTitle="Edit" backPath="/admin" />
        <AjaxErrorBoundary
          busy={busy}
          loadingText="Loading theme"
          errors={errors}
        >
          <ErrorList errors={errors} />
          <Form
            initialValues={theme}
            promise={updateSettings}
            validationSchema={schema}
            onSubmit={() => history.push('/admin')}
          >
            <SettingsForm />
            <DangerZone />
          </Form>
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};
